function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

const redirectionConstants = {

    associationType: {
        NONE: 0,
        CITY: 1,
        STATE: 2,

    },
    associationTypeMap: {
        NONE: 'NONE',
        CITY: 'CITY',
        STATE: 'STATE',
    },
    bulkUploadHeaders: {
        mandatoryHeaders: {
            'Redirection Depot Ref ID': 'depot_ref_id',
        },
        nonMandatoryHeaders: {
            'Redirection Gate Ref ID': 'gate_ref_id',
            'Order Type': 'order_type',
            'Associated Material Categories': 'associated_material_categories',
            'Associated By[State/City]': 'associated_by',
            'Associated Places[State/City]': 'associated_places',
            'Source Depot Ref ID': 'source_depot_ref_id',
        },
    },
    constraints: {
        ORDER_TYPE: 'order_type',
        ASSOCIATED_MATERIAL_CATEGORIES: 'associated_material_categories',
        SOURCE_DEPOT_ID: 'source_depot_id',
    },
};

let redirectionAssociateType = [];
for (const [key, value] of Object.entries(redirectionConstants.associationType)) {
    redirectionAssociateType.push({id: value, name: capitalizeFirstLetter(key)})
}

redirectionConstants.redirectionAssociateType = redirectionAssociateType;

module.exports = {
    redirectionConstants
};
